export default "__VITE_ASSET__tvRPS26P__"